import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../../utils/propUtils';
import VeltCommentDialogSuggestionActionAcceptWireframe from './VeltCommentDialogSuggestionActionAcceptWireframe/VeltCommentDialogSuggestionActionAcceptWireframe';
import VeltCommentDialogSuggestionActionRejectWireframe from './VeltCommentDialogSuggestionActionRejectWireframe/VeltCommentDialogSuggestionActionRejectWireframe';
var VeltCommentDialogSuggestionActionsWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-suggestion-actions-wireframe", __assign({}, transformedProps), children));
};
VeltCommentDialogSuggestionActionsWireframe.Accept = VeltCommentDialogSuggestionActionAcceptWireframe;
VeltCommentDialogSuggestionActionsWireframe.Reject = VeltCommentDialogSuggestionActionRejectWireframe;
export default VeltCommentDialogSuggestionActionsWireframe;
